<template>
  <div class="QuestionDescription">
    <BaseText
      :id="id"
      :label="t(`${i18nRoot}_${id}-label`)"
      :placeholder="t(`${i18nRoot}_${id}-placeholder`)"
      v-model="question!.description"
      rows="4"
      :max-characters="1024"
      :rules="[required]"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRules } from '@/modules/core/composables/useRulesComposable'

import BaseText from '@/modules/core/components/ui/BaseText.vue'
import type QuestionDescription from '@/modules/common/common//models/APP/questionnaire/QuestionDescription'

const { t } = useI18n()
const { required } = useRules()

const i18nRoot = 'copy_questionnaire-form'

interface PropsInterface {
  id: string
}
withDefaults(defineProps<PropsInterface>(), {})

const question = defineModel<QuestionDescription>()
</script>
